import { ReactNode } from 'react';
import WarningIcon from '../assets/icons/warning.svg?react';

export interface WarningBannerProps {
  children: ReactNode;
  className?: string;
}

/**
 * Warning banner component following the Tomra Design System
 * Displays a warning message with an icon and styled background
 */
export function WarningBanner({
  children,
  className = '',
}: WarningBannerProps) {
  return (
    <div
      className={`border-border-warning bg-amber-050 flex items-start gap-3
        rounded border border-amber-400 p-3 ${className}`}
    >
      <WarningIcon className='h-4 w-4 flex-shrink-0 text-amber-400' />
      <span className='size-caption text-primary size-p2'>{children}</span>
    </div>
  );
}
